module.exports = __webpack_public_path__ + "img/credit-card-2-front-fill.63798ea6.svg";